export default "__VITE_ASSET__CgTmAtAy__"